import { type SegmentStatus, segmentStatus } from '@openx/types/segments';
import { AudienceStatus } from '@openx/types/targeting/audience';
import { daysToExpiration } from './daysToExpiration';

export const isSoonToBeExpired = (
  estimatedExpiryDate?: string | null,
  status?: SegmentStatus | AudienceStatus,
  now: Date = new Date()
): boolean => {
  if ((status as SegmentStatus) === segmentStatus.EXPIRED || (status as AudienceStatus) === AudienceStatus.EXPIRED) {
    return false;
  }

  const days = daysToExpiration(estimatedExpiryDate, now);
  if (days === null) return false;

  return days <= 10;
};
